// style-to-inline bake 파이프라인이 주입/식별하는 내부 마커 속성명.
// 'omw' = officemail web — 에디터 라이브러리(@ngweditor, 'ngw')가 주입하는 속성과 네임스페이스를
// 분리해, 우리 bake 가 다루는 마커인지 라이브러리 산물인지 혼선이 없게 한다. 이 모듈은 다른 모듈을
// import 하지 않는 leaf 로 두어, core.ts 와 style-to-inline/index.ts 가 순환 없이 공유한다.

// 뷰어 bake 가 주입하는 의사요소(::before/::after) 보존 <style> 식별 마커.
// 저장물에는 남지 않는 일시 산물이라(뷰어가 pseudoScopeId 전달 시 매번 재수집·재주입) 값 변경은
// 하위호환에 영향이 없다. 한 번의 bake 사이클 내 주입(injectPseudoStyle)과 식별(finishBody·
// applyPseudoStyleScope·collectPseudoElementCSS skipMarker)이 이 같은 값을 공유하기만 하면 된다.
export const PSEUDO_STYLE_MARKER = 'data-omw-pseudo'

// dir="auto" preserve 모드에서 클론 조립 중에만 원 dir 값을 나르는 임시 마커. finalize 에서 제거되어
// 최종 출력물에는 남지 않는다. 입력 HTML 이 위조할 수 있으므로 buildInlineElement 가 기존 마커를
// 항상 제거한 뒤에만 부여한다.
export const DIR_DEFER_ATTR = 'data-omw-defer-dir'
